import { render } from "./BlockTransactions.vue?vue&type=template&id=34bfdd85&scoped=true"
import script from "./BlockTransactions.vue?vue&type=script&lang=js"
export * from "./BlockTransactions.vue?vue&type=script&lang=js"

import "./BlockTransactions.vue?vue&type=style&index=0&id=34bfdd85&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-34bfdd85"

export default script